module.exports = __webpack_public_path__ + "img/home_img02.dcb4163b.png";